<p-toast position="top-right" key="save"></p-toast>
<div class="flex justify-content-evenly align-items-center title-bg titlebg-fixed page-tittle">
  <div class="back-button ml-3 cursor-pointer back-post"
  (click)="navigateToPage(childComponentNavigate)" pTooltip="Back"
    tooltipPosition="right">
    <i class="pi pi-arrow-left backpost-i"></i>
  </div>
  <div style="margin-bottom: 5px;">
    <div class="conten standard-small">
      <div class="btn"><a>{{pageTittleName}}</a></div>
    </div>
  </div>
  <div class="standard-triage">
    <p-dropdown [options]="allStanderdProcessPages" [(ngModel)]="navigatePage" (onChange)="navigateToPage($event);"
      optionValue="FacilityID" optionValue="code" optionLabel="name" [showClear]="false">
    </p-dropdown>
  </div>

</div>

<div class="fixed transform z-1" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>

<!-- pre implementation start -->
<ng-container *ngIf="preImplementationBool">
  <div class="grid">
    <div class="accordian-pre col-12 md:col-12 lg:col-12 mt-2">
      <p-accordion>
        <p-accordionTab header="Pre-Implementation VSM" [selected]="true">
          <div class="p-accordion-header">
            <span class="flex justify-content-end btn-setting">
              <button type="button" class="right-btn mr-2" (click)="SlidePrePost('right','container')"><i
                  class="pi pi-angle-left"></i></button>
              <button type="button" class="right-btn" (click)="SlidePrePost('left','container')"><i
                  class="pi pi-angle-right"></i></button>
            </span>
          </div>
          <div class="p-accordion-content" id="container">
              <div class="app" [ngClass]="i==notespre.length-1 ? 'test': ''"
                *ngFor="let newNote of notespre; let i=index;">
                <app-note class="sticky" *ngFor="let note of newNote.id; let id=index;"
                [roleForFacility]="roleForFacility" [isAccessRead]="isAccessRead"
                  [style.background-color]="newNote.color" [firstElement]='id' (click)="ChangeTableRowColor(id)"
                  [ngClass]="id == 0 ? 'pointerEvent' : 'zIndex'"
                  (dismiss)="DeleteNote(note.id,'pre','preworkflow',newNote.row)"
                  (blur)="AddUpdateNoteData($event,newNote, id,'preworkflow', note.id,id)">
                  <div [innerHTML]="note.text | lineBreak"></div>
                </app-note>
                <div class="relative">
                  <button *ngIf="isAccessReadWrite && !roleForFacility" class="add-cell absolute" id="{{newNote.row}}" style="height:30px"
                    pButton pRipple (click)="AddNewCellInRow(newNote.row,'preworkflow','','')"><i
                      class="pi pi-plus"></i></button>
                </div>
              </div>
          </div>
          <div class="p-accordion-footer mt-1">
            <span class="flex justify-content-end btn-setting">
              <button *ngIf="isAccessReadWrite && !roleForFacility" pButton pRipple label="Save"
                  (click)="SaveUpdateStandardProcessData('preworkflow')" icon="pi pi-check"></button>
            </span>
          </div>
          <!-- sticky notes -->
        </p-accordionTab>
      </p-accordion>
    </div>
    <div class="col-12 md:col-12 lg:col-12 mt-2">
    </div>
    <div *ngIf="!roleForFacility" class="col-12 md:col-12 lg:col-12 mt-2">
      <app-file-upload type="Pre" [firstElement]='3'></app-file-upload>
      <div class="col-12 md:col-12 lg:col-8 col-offset-2 upload-prepost">
        <button (click)="SaveFileUploadData()" [disabled]="UploadDocBool" icon="pi pi-upload" pButton type="button" [loading]="triageFileLoader" label="Upload"></button>
      </div>
    </div>
    <div class="col-12 md:col-12 lg:col-8 col-offset-2">
      <app-view-file-upload
      [getFileUploadStandardProcessArray]="getFileUploadStandardProcessArray"
      (viewDownloadFile)="showDownloadDocument($event);"
      (deleteClick)="DeleteDownloadDocument($event);">
    </app-view-file-upload>
    </div>
  </div>
</ng-container>

<!-- post implementation start -->
<ng-container *ngIf="!preImplementationBool">
  <div [ngStyle]="isAccessRead || roleForFacility?{'pointer-events': 'none'} : {'pointer-events': 'all'}" class="grid mt-4">
    <div class="md:col-12">
      <div class="standard-cld md:col-6">
        <span class="p-input-icon-right w-full flex">
          <label class="slect-date" for="DateofConsult"><b>Select Date:</b></label>
          <p-calendar [showIcon]="true" inputId="icon" [(ngModel)]="selectDatePostVSM">
          </p-calendar>
          <button *ngIf="!roleForFacility" class="add-cell ml-4" style="height:30px" pButton pRipple label="+ Add Post VSM"
            (click)="AddDefaultPostImplementationVSM()"></button>
        </span>
      </div>
    </div>

  </div>

  <div *ngIf="AddPostVSMBool" class="md:col-12 mt-2">
    <!-- Post implementation VSM -->
    <p-accordion *ngFor="let newNoteForRow of notespostVSM;let indx=index;">
      <p-accordionTab header="Post implementation VSM - {{newNoteForRow.date}}" [selected]="false">
        <ng-template pTemplate="header">
          <div class="emstrash-icon" *ngIf="isAccessReadWrite && !roleForFacility" >
            <i class="pi pi-trash icon-trash" pTooltip="Delete Accordion" tooltipPosition="left" (click)="deleteTab($event,indx,newNoteForRow,'VSM', true)"></i>
          </div>
        </ng-template>
        <div class="p-accordion-header">
          <span class="flex justify-content-end btn-setting1">
            <button type="button" class="right1-btn mr-2" (click)="SlidePrePost('right','containervsm_' + indx)"><i
                class="pi pi-angle-left"></i></button>
            <button type="button" class="right1-btn" (click)="SlidePrePost('left','containervsm_' + indx)"><i
                class="pi  pi-angle-right"></i></button>
          </span>
        </div>
        <div class="p-accordion-content" [attr.id]="'containervsm_' + indx">
            <div class="app" *ngFor="let newNote of newNoteForRow.value;">
              <app-note class="sticky" *ngFor="let note of newNote.id; let id=index;"
              [roleForFacility]="roleForFacility" [isAccessRead]="isAccessRead"
                [style.background-color]="newNote.color" [firstElement]='id' (click)="ChangeTableRowColor(id)"
                [ngClass]="id == 0 ? 'pointerEvent' : 'zIndex'"
                (dismiss)="DeleteNote(note.id, 'VSM','postworkflowVSM',newNote.row)"
                (blur)="AddUpdatePostVSMData($event, newNote, id, 'postworkflowVSM', note.id, newNoteForRow.date, id,newNoteForRow.accordion)"
                id="{{note.id}}">
                <div [innerHTML]="note.text | lineBreak"></div>
              </app-note>
              <div class="relative">
                <button *ngIf="isAccessReadWrite && !roleForFacility" class="add-cell absolute" style="height:30px" pButton pRipple label=""
                  (click)="AddNewCellInRow(newNote.row,'postimplementationVSM',newNoteForRow.accordion,indx)"><i
                    class="pi pi-plus"></i></button>
              </div>
            </div>
        </div>
        <div class="p-accordion-footer mt-1">
          <span class="flex justify-content-end btn-setting1">
            <button *ngIf="isAccessReadWrite && !roleForFacility" pButton pRipple label="Save"
            (click)="SaveUpdateStandardProcessData('postworkflowVSM')" icon="pi pi-check"></button>
          </span>
        </div>
        <!-- sticky notes -->
      </p-accordionTab>
    </p-accordion>
  </div>
  <div *ngIf="!roleForFacility" class="md:col-12 mt-2">
    <app-file-upload type="Post" [firstElement]='3'></app-file-upload>
  <div class="col-12 md:col-12 lg:col-8 col-offset-2 upload-prepost">
    <button (click)="SaveFileUploadData()" [disabled]="UploadDocBool" icon="pi pi-upload" pButton type="button" [loading]="triageFileLoader" label="Upload"></button>
  </div>
</div>
  <div class="col-12 md:col-12 lg:col-8 col-offset-2">
    <app-view-file-upload
    [getFileUploadStandardProcessArray]="getFileUploadStandardProcessArray"
    (viewDownloadFile)="showDownloadDocument($event);"
    (deleteClick)="DeleteDownloadDocument($event);">
  </app-view-file-upload>
  </div>
</ng-container>
<!-- Cancle Toast -->
<p-toast [style]="{width: '25vw',opacity:'1'}" position="center" key="c" (onClose)="OnReject()">
  <p-toast key="DeleteContact" position="top-right"></p-toast>
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
        <h4>{{message.summary}}</h4>
        <p>{{message.detail}}</p>
      </div>
      <div class="grid p-fluid">
        <div class="col-6">
          <p-button label="YES" class="ml-2 p-button-primary btn-padding-custom" (click)="OnConfirm()" type="button">
          </p-button>
        </div>
        <div class="col-6">
          <p-button label="No" class="ml-2 p-button-secondary btn-padding-custom" (click)="OnReject()" type="button">
          </p-button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>

<p-toast [style]="{width: '25vw',opacity:'1'}" position="center" key="d" (onClose)="OnReject()">
  <p-toast key="DeleteContact" position="top-right"></p-toast>
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
        <h4>{{message.summary}}</h4>
        <p>{{message.detail}}</p>
      </div>
      <div class="grid p-fluid">
        <div class="col-6">
          <p-button label="YES" class="ml-2 p-button-primary btn-padding-custom" (click)="OnConfirmAccordion()" type="button">
          </p-button>
        </div>
        <div class="col-6">
          <p-button label="No" class="ml-2 p-button-secondary btn-padding-custom" (click)="OnReject()" type="button">
          </p-button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>